module.exports = __webpack_public_path__ + "static/media/1_A1_06.da59eebe.png";